import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Tastemaker.svg'

export const IconTastemaker = IconSVG as IconComponent
